import React from 'react';
import { useInView } from '../hooks/useAnimations';

export default function AnimatedSection({ children, className = '', delay = 0 }) {
    const [ref, isInView] = useInView();

    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: isInView ? 1 : 0,
                transform: isInView ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.8s ease-out ${delay}s, transform 0.8s ease-out ${delay}s`,
            }}
        >
            {children}
        </div>
    );
}
